module.exports = __webpack_public_path__ + "static/media/google-icon.1e01fe36.png";